var btn;
var disable_atc;
var border_width;
var but_width;
var icon;
var heading;
var box_width;
var box_style;
var box_color;
var box_rad;
var but_text;
var but_style;
var but_color;
var but_rad;
var succ_msg;
var succ_color;
var fail_msg;
var fail_color;
var placeholder_text;
var back_color;
var txt_color;
var tooltip_text;
var tooltip_back_color;
var tooltip_txt_color;
var zippyShop;
var zipcode;
var _icon;
var product;
var par;
var msg;
var color;
var lekh;
var overlay;
var set_id;
var utm_source;
var page;
var char_length;
var url;
var output_heading;
var cart_checkout_disabled;
var variant_id;
var widget_layout;

var clicked = 0;
var rules_flag = 1;

url = document.URL;
url = url.split("/");
page = url[url.length - 2];
if (page != "products") {
  page = url[url.length - 1];
}
console.log(page);

zippyShop = Shopify.shop;
/*shop = shop.split("?")[1];
shop = shop.split("=")[1];*/
zippyShop = zippyShop.split(".")[0];
console.log(zippyShop);

utm_source = url[url.length - 1].split("?");
if (utm_source.length > 1) {
  utm_source = utm_source[1].split("&");
  utm_source = utm_source.find(function (item) {
    item = item.split("=");
    item[0] = item[0].toLowerCase();
    return item[0] == "utm_source";
  });
  if (utm_source) {
    utm_source = utm_source.split("=")[1];
  }
} else {
  utm_source = undefined;
}
var timerId_1511_mill = setInterval(function () {
  if (typeof jQuery !== 'undefined' && typeof Shopify !== 'undefined') {

    btn = jQuery("[name='checkout']");
    btn.prop("disabled", true);

    jQuery.get(
      "https://www.risingsigma.com/zippy-v2/scope.php",
      { shop: zippyShop, page: page },
      function (data, status) {
        if (status == "success" && data.prod_here == "1" && data.app_enabled == 1) {
          set_id = data.set_id;
          disable_atc = data.disable_atc;
          succ_msg = data.msg1;
          fail_msg = data.fail_msg;
          char_length = data.char_length;

          jQuery('head').append('<link rel="stylesheet" type="text/css" href="https://www.risingsigma.com/zippy-v2/assets/css/output.css">');
          jQuery('head').append('<script src="https://kit.fontawesome.com/f52954a4c1.js" crossorigin="anonymous"></script>');

          jQuery.get(
            "https://www.risingsigma.com/zippy-v2/json.php",
            { shop: zippyShop },
            function (data, status) {
              if (status == "success" && data.master_value == "1") {
                border_width = data.border_width;
                but_width = data.but_width;
                heading = data.heading;
                box_width = data.box_width;
                box_style = data.box_style;
                box_color = data.box_color;
                box_rad = data.box_rad;
                but_text = data.but_text;
                but_style = data.but_style;
                but_color = data.but_color;
                but_rad = data.but_rad;
                succ_color = data.succ_color;
                fail_color = data.fail_color;
                placeholder_text = data.placeholder_text;
                back_color = data.back_color;
                txt_color = data.txt_color;
                tooltip_text = data.tooltip_text;
                tooltip_back_color = data.tooltip_back_color;
                tooltip_txt_color = data.tooltip_txt_color;
                output_heading = data.output_heading;
                cart_checkout_disabled = data.cart_checkout_disabled;
                widget_layout = data.layout;

                switch (data.icon) {
                  case "1": _icon = "fa-truck"; break;
                  case "2": _icon = "fa-shipping-fast"; break;
                  case "3": _icon = "fa-shopping-cart"; break;
                  case "4": _icon = "fa-map-marker-alt"; break;
                  case "5": _icon = "fa-map-marked-alt"; break;
                  case "6": _icon = "fa-search-location";
                }

                btn.before("<div class='zippy_widget_1511' style='margin-left: auto;'></div>")
                jQuery(".zippy_widget_1511").after("<div id='na-cart-items' style='margin-left: auto; max-width: 412px; display: none; color: red; margin-bottom: 10px; margin-top: 10px; font-weight: bold; font-family:inherit;'>Some items may not be available at your location. Kindly check your cart or reach out to us on chat for more details.</div>");

                zipcode = getCookieZippy("zip");
                if (zipcode != "") {
                  jQuery(".zippy_widget_1511").empty();
                  hasFurbZippyCookie();
                }
                else {
                  noFurbZippyCookie();
                }
              }
            },
            "json"
          );
        }
      },
      "json"
    );
    jQuery(".mini_cart_body").append("<div class='na-cart-items' style='display: none; color: red; margin-bottom: 10px;'></div>");

    function hasFurbZippyCookie() {
      jQuery.get("/cart.js", function (cartResponse) {
        let cartItems = [];
        cartResponse.items.forEach(function (item) {
          cartItems.push(item.handle);
        });
        jQuery(".zippy_widget_1511").empty();
        zipcode = getCookieZippy("zip");
        //console.log(zipcode);
        jQuery.ajax({
          url: "https://www.risingsigma.com/zippy-v2/engine.php",
          data: { set_id: set_id, q: zipcode, clicked: clicked, utm: utm_source, page: page, product: product, variant: variant_id, cart: JSON.stringify(cartItems) },
          type: "GET",
          beforeSend: function () {
            jQuery(".zippy_widget_1511").empty();
            jQuery(".zippy_widget_1511").append('<div class="fas fa-spinner zippy_loading"></div>');
          },
          success: function (data2, status2) {
            jQuery(".zippy_widget_1511").empty();
            jQuery("#na-cart-items").fadeIn();

            let unavailable_items = data2.unavailable_items;
            if (unavailable_items.length != 0 && data2.flag == 0) {
              for (const item of unavailable_items) {
                jQuery(".na-cart-items:eq(" + item[0] + ")").html("This product is not deliverable at " + zipcode + " location.");
                jQuery(".na-cart-items:eq(" + item[0] + ")").fadeIn();
              }
            }/* else if (data2.flag == 0) {
              jQuery(".na-cart-items").html("This product is not deliverable at " + zipcode + " location.");
              jQuery(".na-cart-items").fadeIn();
            }*/
            msg = data2.fail_msg;
            color = fail_color;
            svg = '<svg style="margin-left: 4px; width: 18px; vertical-align: middle;" height="18px" viewBox="0 0 512 512" width="18px" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0" fill="#f44336"/><path d="m350.273438 320.105469c8.339843 8.34375 8.339843 21.824219 0 30.167969-4.160157 4.160156-9.621094 6.25-15.085938 6.25-5.460938 0-10.921875-2.089844-15.082031-6.25l-64.105469-64.109376-64.105469 64.109376c-4.160156 4.160156-9.621093 6.25-15.082031 6.25-5.464844 0-10.925781-2.089844-15.085938-6.25-8.339843-8.34375-8.339843-21.824219 0-30.167969l64.109376-64.105469-64.109376-64.105469c-8.339843-8.34375-8.339843-21.824219 0-30.167969 8.34375-8.339843 21.824219-8.339843 30.167969 0l64.105469 64.109376 64.105469-64.109376c8.34375-8.339843 21.824219-8.339843 30.167969 0 8.339843 8.34375 8.339843 21.824219 0 30.167969l-64.109376 64.105469zm0 0" fill="#fafafa"/></svg>';

            if (status2 == "success" && data2.flag == "1" || unavailable_items.length == 0) {
              jQuery("#na-cart-items").hide();
              msg = data2.msg1;
              color = succ_color;
              svg = '\
                        <svg viewBox="0 0 24 24" fill="#23C5A0" class="tick">\
                            <g fill="none" fill-rule="evenodd">\
                                <path d="M0 0h24v24H0z"></path>\
                                <path fill="#23C5A0" fill-rule="nonzero" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7a.996.996 0 111.41-1.41L10 14.17l6.88-6.88a.996.996 0 111.41 1.41l-7.59 7.59a.996.996 0 01-1.41 0z"></path>\
                            </g>\
                        </svg>\
                        ';
            }
            if (widget_layout == "1") {
              lekh = '\
                        <div class="zipcode_bar_title_1511">\
                            <i class="fa '+ _icon + ' fs-icon" aria-hidden="true"></i>\
                            <span id="delhivery">'+ heading + '</span>\
                        </div>\
                        <div class="zipcode_bar_input_1528" style="border-radius: '+ box_rad + 'px; border-width: ' + box_width + '; border-color: ' + box_color + '; max-width: ' + box_width + 'px; border-style: ' + box_style + ';">\
                            <span class="zipcode_entered">\
                                <span id="zipcode-holder-layout-2">'+ zipcode + '</span>\
                                '+ svg + '\
                            </span>\
                            <span class="change_btn" id="furbChange" style="color: rgb(255, 63, 108);">CHANGE</span>\
                        </div>\
                        <!--<p class="zippy-failure" style="color: '+ color + ';">' + msg + '</p>-->\
                        ';
            } else {
              lekh = '\
                        <div class="zippy-success-card-1511">\
                            <i class="fa fa-map-marker-alt fs-icon" aria-hidden="true"></i>\
                            <button id="furbChange" type="button">'+ output_heading + ' ' + zipcode + '</button>\
                            <p class="zippy-failure" style="color: '+ color + ';">' + msg + '</p>\
                        </div>';
            }

            if (data2.msg && page == "products") {
              lekh += data2.msg;
            }

            jQuery(".zippy_widget_1511").append(lekh);
            
            if(unavailable_items.length != 0) {
              jQuery(".zippy-failure").css("display", "none");
            }

            if (jQuery(".zippy_widget_1511").length != 0) {
              furbDisableFuncZippy();
            }

            if (status2 == "success" && data2.flag == "1" || unavailable_items.length == 0) {
              if (btn.parent().is("#wrapper-1511")) {
                jQuery(".tooltip-1511").remove();
                jQuery("#overlay-1511").remove();
                btn.removeAttr("disabled");
                btn.off("focus");
                jQuery("#overlay-1511").mouseenter();
                jQuery("#overlay-1511").mouseleave();
                btn.unwrap();
              }
            }

            jQuery("#furbChange").click(function () {
              jQuery(".na-cart-items").fadeOut();
              jQuery("#na-cart-items").fadeOut();
              noFurbZippyCookie();
            });

          },
          dataType: "json"
        });
      }, dataType = "json");
    }

    function noFurbZippyCookie() {
      jQuery(".zippy_widget_1511").empty();
      jQuery.get(
        "https://www.risingsigma.com/zippy-v2/engine.php",
        data = { shop: zippyShop }
      );

      if (widget_layout == "1") {
        lekh = '\
            <div class="zipcode_bar_title_1511">\
                <i class="fa '+ _icon + ' fs-icon" aria-hidden="true"></i>\
                <span id="delhivery">'+ heading + '</span>\
            </div>\
            <div class="zipcode_bar_input_1528" style="border-radius: '+ box_rad + 'px; border-width: ' + border_width + '; border-color: ' + box_color + '; max-width: ' + box_width + 'px; border-style: ' + box_style + ';">\
                <form id="formide">\
                    <input class="zipcode_bar_inputbox_1528" id="furbPin" type="text" placeholder="'+ placeholder_text + '" maxlength = "' + char_length + '" autocomplete="off">\
                    <button class="zipcode_bar_btn_1528" style="color: ' + txt_color + ';" id="furbCheckPin" type="button">' + but_text + '</button>\
                </form >\
            </div >\
            ';
      } else {
        lekh = '\
            <div class="zipcode_bar_title_1511">\
                <i class="fa '+ _icon + ' fs-icon" aria-hidden="true"></i>\
                <span id="delhivery">'+ heading + '</span>\
            </div>\
            <div class="zipcode_bar_input_1511">\
                <form id="formide">\
                    <input style="border-radius: ' + box_rad + 'px; border-width: ' + border_width + '; border-color: ' + box_color + '; width: ' + box_width + 'px; border-style: ' + box_style + ';" id="furbPin" type="text" placeholder="' + placeholder_text + '" autocomplete="off" maxlength="' + char_length + '">\
                    <button style="border-radius: ' + but_rad + 'px; border-width: ' + but_width + '; border-color: ' + but_color + '; border-style: ' + but_style + '; background-color: ' + back_color + '; color: ' + txt_color + ';" id="furbCheckPin" type="button">' + but_text + '</button>\
                </form>\
            </div>\
            ';
      }

      jQuery(".zippy_widget_1511").append(lekh);

      if (jQuery(".zippy_widget_1511").length != 0) {
        furbDisableFuncZippy();
      }

      jQuery("#furbPin").on("keyup", function (event) {
        if (event.keyCode === 13) {
          jQuery("#furbCheckPin").click();
        }
      });

      jQuery("#formide").submit(function (e) {
        e.preventDefault();
      });

      jQuery("#furbCheckPin").click(function () {
        clicked = 1;
        let str = jQuery("#furbPin").val().trim();
        if (str.length == 0) {
          jQuery("#pin_fail").css("display", "block");
          jQuery("#pin_fail").fadeIn();
          jQuery("#pin_fail").html("Please enter a valid input.");
          setTimeout(function () {
            jQuery("#pin_fail").fadeOut();
          }, 2222);
        } else {
          setCookieZippy("zip", str);
          hasFurbZippyCookie();
        }
      });
    }

    function furbDisableFuncZippy() {
      if (btn.parent().is("#wrapper-1511")) {
        jQuery(".tooltip-1511").remove();
        jQuery("#overlay-1511").remove();
        btn.removeAttr("disabled");
        // btn.css("width", "initial");
        btn.off("focus");
        jQuery("#overlay-1511").mouseenter();
        jQuery("#overlay-1511").mouseleave();
        btn.unwrap();
      }
      //if (cart_checkout_disabled == "1") {
      btn.wrap("<div id='wrapper-1511'></div>");
      jQuery("#wrapper-1511").prepend("<div id='overlay-1511'></div>");
      overlay = jQuery("#overlay-1511");
      overlay.height(jQuery("#wrapper-1511").height());
      overlay.width(jQuery("#wrapper-1511").width());
      overlay.css("cursor", "not-allowed");
      btn.before('<div class="tooltip-1511">\
                <div class="tooltip-content-1511" style="background: ' + tooltip_back_color + '; color: ' + tooltip_txt_color + ';">' + tooltip_text + '</div>\
                <div class="arrow-bottom-1511" style="border-top-color: '+ tooltip_back_color + '"></div>\
            </div>');
      btn.attr("disabled", "disabled");
      // btn.css("width", "100%");
      btn.on("focus", function () {
        btn.css("outline", "none");
      });
      let y = jQuery("#wrapper-1511").height() + jQuery(".tooltip-1511").height() / 3;
      overlay.mouseenter(function () {
        jQuery(".tooltip-1511").css("top", "-" + (y + 105) + "px");
        jQuery(".tooltip-1511").css("right", "25%");
        jQuery(".tooltip-1511").css("display", "inline-block");
      });
      overlay.mouseleave(function () {
        jQuery(".tooltip-1511").css("display", "none");
      });
      // console.log("Disabled");
      //}
    }

    clearInterval(timerId_1511_mill);
  }
  else
    console.log("jQuery not loaded.");
}, 50);

function setCookieZippy(cname, cvalue) {
  let exdays = 7;
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; Path=/; SameSite=None; Secure";
}

function getCookieZippy(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}